'use client';

import { supporterDetailsQuery } from '../queries.ts';
import {
  getSupporterEmail,
  getSupporterFullName,
  getSupporterInitials,
  getSupporterPreferredName,
} from '../utils/name-format.ts';
import { useSupporterQuery } from './base.ts';

export enum NameFormats {
  preferred = 'preferred',
  full = 'full',
  initials = 'initials',
  email = 'email',
}

export const useSupporterDetails = () => {
  return useSupporterQuery(supporterDetailsQuery);
};

export const useSupporterName = (format: NameFormats) => {
  const query = useSupporterDetails();
  const { data: details } = query;

  if (!details) {
    return {
      ...query,
      name: undefined,
    };
  }

  let name: string | undefined;

  switch (format) {
    case NameFormats.full: {
      name = getSupporterFullName(details);
      break;
    }
    case NameFormats.initials: {
      name = getSupporterInitials(details);
      break;
    }
    case NameFormats.email: {
      name = getSupporterEmail(details);
      break;
    }
    default: {
      name = getSupporterPreferredName(details);
      break;
    }
  }

  return {
    ...query,
    name,
  };
};
